import { StyledAnchorTag, StyledLinkTag } from './style';
import { ReactNode } from 'react';

interface AnchorTagProps {
  isPageRefreshRequired?: boolean;
  dataTestId?: string;
  className?: string;
  to?: string;
  children?: ReactNode;
  onClick?: () => void;
}

const AnchorTag = ({
  isPageRefreshRequired,
  dataTestId,
  className,
  to,
  children,
  onClick,
}: AnchorTagProps) => {
  if (isPageRefreshRequired) {
    return (
      <StyledAnchorTag data-testid={dataTestId} className={className} href={to} onClick={onClick}>
        {children}
      </StyledAnchorTag>
    );
  }

  return (
    <StyledLinkTag data-testid={dataTestId} className={className} to={to} onClick={onClick}>
      {children}
    </StyledLinkTag>
  );
};

export default AnchorTag;
